import React from 'react';
import './SecureCheckoutLabel.css';

export default function SecureCheckoutLabel({ showCards = true }) {
  return (
    <div className="secureCheckoutLabel" data-testid="secureCheckoutLabel">
      {showCards ? (
        <picture>
          <source
            media="(min-width: 650px)"
            width="374"
            height="24"
            srcSet="/account/static/images/cards/secure-checkout-01.png"
          />
          <source
            media="(min-width: 465px)"
            width="189"
            height="46"
            srcSet="/account/static/images/cards/secure-checkout-small-01.png"
          />
          <img
            className="secureCheckout"
            src="/account/static/images/cards/secure-checkout-small-01.png"
            alt="secure checkout"
          />
        </picture>
      ) : (
        <img
          className="secureCheckout safeCheckout"
          src="/account/static/images/cards/safe-checkout-green.png"
          width="189"
          height="23"
          alt="secure checkout"
        />
      )}
    </div>
  );
}
